import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: '100%',
      width: '100%',
      display: 'flex',

      '& aside': {
        overflowY: 'auto',
      },
    },
    leftNode: {
      position: 'relative',
      height: '100%',
      width: '100%',
    },
  }),
)
